import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/analyticsjobs",
		component: lazy(() => import("./AdminAnalyticsDashboardPage")),
	},
]);
